import { render, staticRenderFns } from "./SecretSantaView.vue?vue&type=template&id=7e89ce68&"
import script from "./SecretSantaView.vue?vue&type=script&lang=js&"
export * from "./SecretSantaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports